import "./FormStyles.css";
import React from 'react'

const Form = () => {
    return (
        <div className="form">
            <form>
                <label>Your name</label>
                <input type="text" placeholder="Enter your name"></input>
                <label>Email</label>
                <input type="email" placeholder="Enter your email"></input>
                <label>Subject</label>
                <input type="text" placeholder="Subject" ></input>
                <label>Message</label>
                <textarea rows="6" placeholder="Enter your message here"></textarea>
                <button className="btn">Submit</button>
            </form>

        </div>
    )
}

export default Form
